// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__PxxIj {
  margin-top: 20px;
  background-color: #1f1f1f;
  height: 170px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.Footer_footer__PxxIj .Footer_info-text__ov8E- {
  color: white;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 40%;
  margin-left: 3%;
}
.Footer_footer__PxxIj .Footer_info-text__ov8E- .Footer_info-text-container__wrl86 {
  margin-right: 100px;
}
.Footer_footer__PxxIj .Footer_info-text__ov8E- .Footer_buttons__0GBMP Button {
  margin-top: 9px;
}

.Footer_tooltip-text__tlRIb {
  width: 300px;
  height: 110px;
  margin-left: 20px;
}
.Footer_tooltip-text__tlRIb .Footer_copy-email__NO7Hb {
  color: #054ab0;
  font-size: 16px;
}

.Footer_title__xdj5Y {
  font-weight: bold;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,yBCCU;EDAV,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AADF;AAEE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;AAAJ;AACI;EACE,mBAAA;AACN;AACI;EACE,eAAA;AACN;;AAIA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AADF;AAEE;EACE,cC9BK;ED+BL,eE/BK;AF+BT;;AAIA;EACE,iBE/BK;EFgCL,eEnCS;AFkCX","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.footer {\n  margin-top: 20px;\n  background-color: colors.$secondary;\n  height: 170px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  .info-text {\n    color: white;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n    width: 40%;\n    margin-left: 3%;\n    .info-text-container {\n      margin-right: 100px;\n    }\n    .buttons Button {\n      margin-top: 9px;\n    }\n  }\n}\n\n.tooltip-text {\n  width: 300px;\n  height: 110px;\n  margin-left: 20px;\n  .copy-email {\n    color: colors.$accent;\n    font-size: typography.$body-l;\n  }\n}\n\n.title {\n  font-weight: typography.$bold;\n  font-size: typography.$header-s;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__PxxIj`,
	"info-text": `Footer_info-text__ov8E-`,
	"info-text-container": `Footer_info-text-container__wrl86`,
	"buttons": `Footer_buttons__0GBMP`,
	"tooltip-text": `Footer_tooltip-text__tlRIb`,
	"copy-email": `Footer_copy-email__NO7Hb`,
	"title": `Footer_title__xdj5Y`
};
export default ___CSS_LOADER_EXPORT___;
